
import SignInFormComponent from "@/components/auth/LoginForm.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "SignInPage",
  components: {
    SignInFormComponent,
  },
  /* computed */
  computed: {
    getSignInError() {
      return this.$store.getters["auth/signInError"];
    },
  },
});
